import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import {
  AddCircleOutlined,
  CheckCircleOutlined,
  EditOutlined,
  NoteAddOutlined,
  NotesOutlined,
} from "@mui-symbols-material/w300"

import { LocationMenuDialogs } from "./types/dialogs"

import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface TableRowDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  hasNote: boolean
  hasAddress: boolean
  isActive: boolean
  openDialog: (dialog: LocationMenuDialogs) => void
  open: boolean
  isCustomerCompanyType: boolean
  toggleActiveDisabled: boolean
  onToggleActive: () => void
}

const TableRowDropdownMenu: React.FC<TableRowDropdownMenuProps> = ({
  anchorEl,
  onClose,
  isActive,
  hasNote,
  hasAddress,
  openDialog,
  open,
  toggleActiveDisabled = false,
  onToggleActive,
  isCustomerCompanyType,
}) => {
  const { hasPermissions } = usePermissionManager()

  const hasPermissionEditSalesman = hasPermissions([PermissionActionType.CUSTOMER_MAINTENANCE])

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      {/* Address group */}
      <MenuItem onClick={() => openDialog(LocationMenuDialogs.EDIT_ADDRESS)}>
        <ListItemIcon>
          <EditOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Edit Location' />
      </MenuItem>

      {isCustomerCompanyType && hasPermissionEditSalesman && (
        <MenuItem onClick={() => openDialog(LocationMenuDialogs.EDIT_SALES_PERSON)}>
          <ListItemIcon>
            <CheckCircleOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
          </ListItemIcon>
          <ListItemText primary='Update Salesperson' />
        </MenuItem>
      )}

      {!isCustomerCompanyType && (
        <MenuItem onClick={() => openDialog(LocationMenuDialogs.EDIT_ACCOUNT_MANAGER)} hidden={!hasAddress}>
          <ListItemIcon>
            <CheckCircleOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
          </ListItemIcon>
          <ListItemText primary='Update Account Manager' />
        </MenuItem>
      )}

      <MenuItem disabled={toggleActiveDisabled} onClick={onToggleActive}>
        <ListItemIcon>
          <AddCircleOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary={isActive ? "Deactivate" : "Activate"} />
      </MenuItem>
      <Divider variant='fullWidth' />
      {/* Note group */}
      <MenuItem onClick={() => openDialog(LocationMenuDialogs.EDIT_NOTES)} hidden={!hasNote}>
        <ListItemIcon>
          <NotesOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Edit Note' />
      </MenuItem>
      <MenuItem onClick={() => openDialog(LocationMenuDialogs.ADD_NOTES)} hidden={hasNote}>
        <ListItemIcon>
          <NoteAddOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Add Note' />
      </MenuItem>
    </Menu>
  )
}

export default TableRowDropdownMenu
